import React from 'react';
import DescriptionListItem from 'components/v2/DescriptionListItem';

const ShipmentDetailIndividualItem = ({ dataTestId, title, value, href }) => {
  return (
    <div data-testid={dataTestId} className="mb-4 sm:col-span-1">
      <div data-testid="div-977c0dbc" className="flex items-center max-w-full">
        <span data-testid="span-84c7a391" className="mb-0 mr-3 max-w-full ">
          {
            <DescriptionListItem
              dataTestId="DescriptionListItem-a4bd4d92"
              className="sm:col-span-1"
              label={title}
            >
              {href ? (
                <a
                  data-testid="a-726d2d58"
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-700 cursor-pointer hover:text-blue-600"
                >
                  <span data-testid="span-5b9a35c1">{value}</span>
                </a>
              ) : (
                <span data-testid="span-5b9a35c2">{value}</span>
              )}
            </DescriptionListItem>
          }
        </span>
      </div>
    </div>
  );
};

export default ShipmentDetailIndividualItem;
